var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Plotly',{attrs:{"layout":_vm.plotlyLayout,"data":_vm.plotlyData}})
}
var staticRenderFns = []

export { render, staticRenderFns }